import { Outlet, useLocation } from 'react-router-dom';

import { useReleaseAuthEntrances } from '../lib/authEntrance';
import { useLanguage } from '../lib/i18n/LanguageContext';
import { AuthSplitShell } from './AuthSplitShell';

const AUTH_ENTRANCE_KEYS = [
  'copy-login',
  'copy-signup',
  'copy-forgot',
  'shell-login',
  'shell-signup',
  'shell-forgot',
  'signin-credentials',
  'signin-code',
  'signup-form',
  'signup-pending',
  'forgot-form',
  'forgot-sent',
] as const;

/** Keeps auth decor mounted while login ↔ signup ↔ forgot crossfade. */
export function AuthCredentialsLayout() {
  const location = useLocation();
  const { dict } = useLanguage();

  const routeKey =
    location.pathname === '/signup'
      ? 'signup'
      : location.pathname === '/forgot-password'
        ? 'forgot'
        : 'login';

  const copy =
    routeKey === 'signup'
      ? {
          eyebrow: dict.signUp.welcomeEyebrow,
          headline: dict.signUp.welcomeHeadline,
          body: dict.signUp.welcomeBody,
        }
      : routeKey === 'forgot'
        ? {
            eyebrow: dict.forgotPassword.welcomeEyebrow,
            headline: dict.forgotPassword.welcomeHeadline,
            body: dict.forgotPassword.welcomeBody,
          }
        : {
            eyebrow: dict.signIn.welcomeEyebrow,
            headline: dict.signIn.welcomeHeadline,
            body: dict.signIn.welcomeBody,
          };

  useReleaseAuthEntrances(AUTH_ENTRANCE_KEYS);

  return (
    <AuthSplitShell routeKey={routeKey} {...copy}>
      <Outlet />
    </AuthSplitShell>
  );
}
